import { Helmet } from 'react-helmet';

export default Helmet;
